import React from 'react';
import { PARAM_EMPTY_VALUE } from '@beefco/core';
export var GlobalBridgeContext = /*#__PURE__*/React.createContext(null);

/**
 * Holding current adaptivity interval
 */
export var AdaptiveContext = /*#__PURE__*/React.createContext(PARAM_EMPTY_VALUE);